export enum DutyOfCareSubscriptionOptions {
  AutoRenewal = 'autoRenewal',
}
